import { IDisplayItem, IDisplayItemProperty, IScreenDesignDto } from "@kuika/kuika-cl-model";
import { ScreenDesignHelper } from "../../../../shared/utility/screen-design-helper";

/** The visual identity of a button component, for rendering a small styled preview pill. */
export interface IButtonPreview {
  label: string;
  textColor: string;
  backgroundColor: string;
}

/**
 * Extracts a button component's label + colors from its screen design, the same way
 * `AddButtonModal` reads them back for editing. Falls back to the modal's create defaults
 * (white on `#0358ff`) when the design carries no explicit style, and to the screen name
 * when it carries no label — so a preview always renders something sensible.
 */
export const parseButtonPreview = (button: IScreenDesignDto): IButtonPreview => {
  const fallback: IButtonPreview = { label: button.name, textColor: "#ffffff", backgroundColor: "#0358ff" };
  try {
    const screenModel: { displayItems?: IDisplayItem[] } = JSON.parse(button.json);
    const displayItems: IDisplayItem[] = screenModel?.displayItems ?? [];
    const buttonDi: IDisplayItem | undefined = ScreenDesignHelper.findDisplayItemByComponentName(
      "Button",
      displayItems
    );
    if (!buttonDi) return fallback;
    const labelProperty: IDisplayItemProperty | undefined = buttonDi.item?.properties?.find(
      (p: IDisplayItemProperty): boolean => p.name === "label"
    );
    const label: string = String(labelProperty?.symbol?.fixedValue ?? "") || button.name;
    return {
      label,
      textColor: buttonDi.styleObj?.text?.color ?? fallback.textColor,
      backgroundColor: buttonDi.styleObj?.fill?.color ?? fallback.backgroundColor
    };
  } catch {
    return fallback;
  }
};
